import React, { memo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Popup } from "react-mapbox-gl";
import { makeStyles } from "@mui/styles";
import { RouteMarker } from "./RouteMarker";
import {
  isZoomingSelector,
  popupDetailsSelector,
  lastPopupDetailsSelector,
} from "../../../reducers/map/selectors";
import {
  isEditOneModeSelector,
  overlayDetailsSelector,
} from "../../../reducers/matrixProfile/selectors";

const useStyles = makeStyles({
  root: {
    zIndex: "50 !important",
  },
});

export const RouteLabelPopUp = memo(({ setPopupDetailsFromCords }) => {
  const styles = useStyles();

  const isEditOneMode = useSelector(isEditOneModeSelector);
  const overlayDetails = useSelector(overlayDetailsSelector);
  const {
    coordinates = [0, 0],
    routes = [],
    postcode,
  } = useSelector(popupDetailsSelector) || {};
  const { point: lastPoint, coordinates: lastCoordinates } =
    useSelector(lastPopupDetailsSelector) || {};
  const isZooming = useSelector(isZoomingSelector);
  const [prevIsZooming, setPrevIsZooming] = useState();
  const isEditWithOverlay = isEditOneMode && !!overlayDetails;

  useEffect(() => {
    if (isZooming === prevIsZooming) return;
    setPrevIsZooming(isZooming);
    isEditWithOverlay &&
      lastPoint &&
      setPopupDetailsFromCords({
        point: lastPoint,
        lngLat: {
          lng: lastCoordinates[0],
          lat: lastCoordinates[1],
        },
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isZooming, prevIsZooming, lastPoint, lastCoordinates, isEditWithOverlay]);

  if (!coordinates || !isEditWithOverlay) return null;
  else
    return (
      <Popup
        coordinates={coordinates}
        anchor={"top-left"}
        offset={[0, 10]}
        className={styles.root}
      >
        <RouteMarker
          routes={routes}
          postcode={postcode}
          individual
          showArrow={false}
          showNoVolume={true}
        />
      </Popup>
    );
});
